import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Route, Router, RouterStateSnapshot } from '@angular/router';
import { ContentsCalculatorComponent } from '../pages/contents-calculator/contents-calculator.component';
import { NavButtonsService } from '../services/nav-buttons-service/nav-buttons.service';
import { HouseholdQuoteStateService } from '../services/household-quote-state-service/household-quote-state.service';
import { FormNames } from '../models/enums/quote-form-names';
import { CalculatorService } from '../services/contents-calculator/calculator-service/calculator.service';
import { Subscription } from 'rxjs';
import { ContentsCalcFormBuilderService } from '../services/contents-calculator/contents-calc-form-builder/contents-calc-form-builder.service';
@Injectable({
    providedIn: 'root'
})
export class ContentsCalculatorGuard {
    private childRoutesCount: number = 0;
    private canExit: boolean = false;
    private subSink: Subscription = new Subscription();

    constructor(public router: Router,
        private NavBtnService: NavButtonsService,
        private householdQuoteStateService: HouseholdQuoteStateService,
        public calcService: CalculatorService,
        private contentsCalculatorFormBuilderService: ContentsCalcFormBuilderService) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        return this.isAllowedNavigate();
    }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        this.childRoutesCount++;
        return this.canActivate(route, state);
    }

    canDeactivate(component: ContentsCalculatorComponent,
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot,
        nextState: RouterStateSnapshot): boolean {

        if (this.householdQuoteStateService.hasFormState(FormNames.contentsCalcForm)) {
            let quoteForm = this.householdQuoteStateService.getFormState(FormNames.contentsCalcForm).form;
            if(quoteForm.dirty) {
                if(!this.canExit){
                    this.calcService.openUnsavedChangesPopup();
                    this.router.navigateByUrl(state.url.toString());
                    return false;
                } else {
                    this.contentsCalculatorFormBuilderService.getContentsCalcQuoteForm(true);
                }
            }
        }

        let currentNavigation = this.router.getCurrentNavigation();
        if (currentNavigation.trigger == 'popstate') {
            this.childRoutesCount--;
        }
        this.NavBtnService.skipRoutes(this.childRoutesCount);
        this.childRoutesCount = 0;
        return true;
    }

    canLoad(route: Route): boolean {
        this.childRoutesCount = 0;
        this.subSink.add(
            this.calcService.getCanExitCalculator().subscribe((canExit) => {
                this.canExit = canExit;
            })
        )
        return true;
    }

    isAllowedNavigate(): boolean {
        let currentNavigation = this.router.getCurrentNavigation();
        if (currentNavigation.trigger == 'popstate' && this.childRoutesCount > 1) {
            this.childRoutesCount -= 2;
        }
        return true;
    }
}
